import React from 'react';

import { useSnackbar } from 'notistack';

import { Box, Button } from '@mui/material';

import { enqueueReport } from '~/services/ReportingService';

export default function PreferredSalesAgentReportForm() {
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async () => {
    try {
      await enqueueReport('preferred-sales-agent', {});
      enqueueSnackbar(`Your report is being downloaded.`, { variant: 'success' });
    } catch (err) {
      enqueueSnackbar(`Report error: ${err.message}`, { variant: 'error' });
    }
  };

  return (
    <Box>
      <Button onClick={handleSubmit} variant="contained">
        Email Preferred Sales Agent Report (.XLSX)
      </Button>
    </Box>
  );
}
